import React from 'react';

const IconArrow = (props) => {
    const { direction } = props;
    return direction == "left" ? <svg
        width="13"
        height="8"
        viewBox="0 0 13 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5 4.18201C12.7761 4.18201 13 3.95815 13 3.68201C13 3.40586 12.7761 3.18201 12.5 3.18201V3.68201V4.18201ZM0.146447 3.32845C-0.0488155 3.52372 -0.0488155 3.8403 0.146447 4.03556L3.32843 7.21754C3.52369 7.4128 3.84027 7.4128 4.03553 7.21754C4.2308 7.02228 4.2308 6.7057 4.03553 6.51043L1.20711 3.68201L4.03553 0.85358C4.2308 0.658318 4.2308 0.341735 4.03553 0.146473C3.84027 -0.0487893 3.52369 -0.0487893 3.32843 0.146473L0.146447 3.32845ZM12.5 3.68201V3.18201H0.5V3.68201V4.18201H12.5V3.68201Z"
            fill="black"
        />
    </svg> : <svg
        width="13"
        height="8"
        viewBox="0 0 13 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.5 3.18201C0.223858 3.18201 2.41411e-08 3.40586 0 3.68201C-2.41411e-08 3.95815 0.223858 4.18201 0.5 4.18201L0.5 3.68201L0.5 3.18201ZM12.8536 4.03556C13.0488 3.8403 13.0488 3.52372 12.8536 3.32845L9.67157 0.146473C9.47631 -0.0487895 9.15973 -0.0487896 8.96447 0.146473C8.7692 0.341735 8.7692 0.658317 8.96447 0.853579L11.7929 3.68201L8.96447 6.51043C8.7692 6.7057 8.7692 7.02228 8.96447 7.21754C9.15973 7.4128 9.47631 7.4128 9.67157 7.21754L12.8536 4.03556ZM0.5 3.68201L0.5 4.18201L12.5 4.18201L12.5 3.68201L12.5 3.18201L0.5 3.18201L0.5 3.68201Z"
            fill="black"
        />
    </svg>;
};

export default IconArrow;
